import { cloneDeep } from 'lodash-es'

function language_exclusion({ value }) {
  if (!value.raw) return
  const pattern = /^[а-яА-Я\s]*$/
  return pattern.test(value.raw)
}

export const schema = [
  {
    $el: 'div',
    attrs: {
      class: 'grid md:grid-cols-4 gap-3',
    },
    children: [
      {
        classes: { outer: 'col-span-3' },
        $formkit: 'fio',
        name: 'fio',
        label: 'ФИО',
        placeholder: 'Иванов Иван Иванович',
        validation: 'language_exclusion',
        validationVisibility: 'live',
        validationRules: { language_exclusion },
        validationMessages: {
          language_exclusion: 'Пожалуйста используйте кириллицу',
        },
      },
      {
        classes: { outer: 'col-span-1' },
        $formkit: 'number',
        name: 'age',
        label: 'Возраст',
        placeholder: '10',
      },
    ],
  },
  {
    $formkit: 'textarea',
    name: 'school',
    label: 'Образовательное учреждение',
    placeholder: 'Школа №1',
  },
  {
    $formkit: 'text',
    name: 'class',
    label: 'Класс/группа',
    placeholder: '7а',
  },
  {
    $formkit: 'textarea',
    name: 'additional',
    label: 'Дополнительное образование/курсы',
    placeholder: 'Кружок рисования',
  },
  {
    $formkit: 'textarea',
    name: 'interests',
    label: 'Увлечения',
    placeholder: 'Стихи',
  },
  {
    $formkit: 'textarea',
    name: 'slogan',
    label: 'Девиз',
    placeholder: 'Дорога возникает под шагами идущего',
  },
  {
    $formkit: 'textarea',
    name: 'achievements',
    label: 'Достижения',
    placeholder: 'Конкурс «А.С. Пушкин голосами детей» Первое место',
  },
  {
    $formkit: 'file',
    name: 'default',
    label: 'Фотографии',
    accept: ['image/png', 'image/jpeg', 'image/jpg'],
  },
  {
    $formkit: 'file',
    name: 'gallery',
    label: 'Доп. фотографии',
    accept: ['image/png', 'image/jpeg', 'image/jpg'],
    max: 5,
  },
  {
    $formkit: 'file',
    name: 'uploads',
    label: 'Файлы',
    accept: ['application/pdf', 'video/mp4'],
    max: 5,
  },
]

export function transformData(record) {
  if (!record) {
    return cloneDeep(record)
  }

  const result = cloneDeep(record).media?.reduce((acc, item) => {
    const collection = item.collection
    if (!acc[collection]) {
      acc[collection] = []
    }
    acc[collection].push(item)
    return acc
  }, {})

  return { ...record, ...result }
}
